import React from 'react';

import Icon, { Props } from './icon';

export const PlaySentSending: React.FC<Props> = (props: Props) => {
  return (
    <Icon {...props} viewBox="0 0 40 40">
      <path d="M24.3657 20.5346L17.4501 25.2941C17.1184 25.5224 16.6667 25.2849 16.6667 24.8822V15.892C16.6667 15.5015 17.0944 15.2617 17.4276 15.4655L24.3431 19.6962C24.6519 19.8851 24.6639 20.3294 24.3657 20.5346Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.33333 9.36675C6.61536 9.36675 6.03333 9.94878 6.03333 10.6668V29.3335C6.03333 30.0514 6.61536 30.6335 7.33333 30.6335H32.6666C33.3846 30.6335 33.9666 30.0514 33.9666 29.3335V10.6668C33.9666 9.94878 33.3846 9.36675 32.6666 9.36675H7.33333ZM3.33333 10.6668C3.33333 8.45761 5.12419 6.66675 7.33333 6.66675H32.6666C34.8758 6.66675 36.6666 8.45761 36.6666 10.6668V29.3335C36.6666 31.5426 34.8758 33.3335 32.6666 33.3335H7.33333C5.12419 33.3335 3.33333 31.5426 3.33333 29.3335V10.6668Z"
        fill="white"
      />
    </Icon>
  );
};

export default React.memo(PlaySentSending);
